export const DTU10 = {
  title: {
    value: 'DTU 10 Tide',
  },
  paragraph: {
    value: `DTU10 (Cheng and Andersen, 2010) is a state-of-art global tide model derived from many years of satellite altimetry and tide gauge station data around the world. It is a data-derived model providing tidal constituents to predict astronomical tide levels in any point of the ocean at any given time.`,
  },
  table: {
    value: {
      header: ['General', 'Model'],
      hiddenHeaders: ['Model'],
      rows: [
        {
          General: 'Title',
          Model: 'DTU10 Global Ocean Tide Model',
        },
        {
          General: 'Geographical Coverage',
          Model: 'Global',
        },
        {
          General: 'Category',
          Model: 'Sea water levels and Currents',
        },
        {
          General: 'Source Name',
          Model: 'Tidal model, TPXO8-DTU10',
        },
        {
          General: 'Publisher',
          Model: 'DTU Space (Technical University of Denmark)',
        },
        {
          General: 'Product type',
          Model: 'Grid',
        },
        {
          General: 'Cost (ex. VAT)',
          Model: 'Free',
        },
        {
          General: 'Typical Applications',
          Model: 'Hydrodynamic, wave, Offshore and Marine projects',
        },
        {
          General: 'References',
          Model: `DTU Space home: ***https://www.space.dtu.dk/english*** Global Ocean Tide Model (dtu.dk): ***https://www.space.dtu.dk/english/research/scientific_data_and_models/global-ocean-tide-model***`,
        },
      ],
    },
  },
  table1: {
    value: {
      header: ['Coverage', 'Model'],
      hiddenHeaders: ['Model'],
      rows: [
        {
          Coverage: 'Geographical Range',
          Model: 'Global',
        },
        {
          Coverage: 'Geographical Resolution',
          Model: `Tidal wave constituents; global resolution for tide and current prediction:
                    Water level : 0.125 deg.
                    Currents : 0.25 deg.`,
        },
        {
          Coverage: 'Vertical Reference',
          Model: 'Sea Surface',
        },
        {
          Coverage: 'Temporal Reference',
          Model: 'UTC',
        },
        {
          Coverage: 'Temporal Range',
          Model: 'Unlimited',
        },
        {
          Coverage: 'Temporal Resolution',
          Model: 'Flexible',
        },
      ],
    },
  },
  table2: {
    value: {
      header: ['Variables', 'Model'],
      hiddenHeaders: ['Model'],
      rows: [
        {
          Variables: 'Name (Unit) Range',
          Model: `Sea water level [m]
                    East Current velocity [m/s]
                    North Current velocity [m/s]`,
        },
      ],
    },
  },
  table3: {
    value: {
      header: ['Credits', 'Model'],
      hiddenHeaders: ['Model'],
      rows: [
        {
          Credits: 'Authors',
          Model: `Yongcun Cheng, Ole Baltazar Andersen, (2010). Improvement in global ocean tide model in shallow water regions. Poster, SV.1-68 45, OSTST, Lisbon, Oct.18-22.`,
        },
      ],
    },
  },
};
